@if (user$|async; as user) {
  <div class="ml-2 w-50 flex items-center">
    <button
      type="button"
      class="w-full overflow-hidden overflow-ellipsis font-bold text-lg uppercase text-right whitespace-nowrap inline-flex items-center"
      (click)="onToggle()"
      >
      <svg class="w-6 h-6 mr-2.5 text-sky-500">
        <use [attr.xlink:href]="'assets/icons/navigation.svg#user'"></use>
      </svg>
      {{user.name}}
    </button>
  </div>
  @if (isOpen$|async) {
    <div class="relative">
      <div class="absolute right-10 -top-5 w-11 overflow-hidden inline-block">
        <div class="h-16 bg-sky-500 rotate-45 transform origin-bottom-left"></div>
      </div>
      <div
        class="absolute right-10 mt-[1.6rem] z-10 w-56 px-8 py-7 origin-top-right rounded-lg bg-sky-500 shadow-lg focus:outline-none"
        role="menu"
        tabindex="-1"
        (clickOutside)="onClose()"
        >
        <h3 class="text-black text-2xl font-bold">{{user.name}}</h3>
        <div class="mt-2 py-1" role="none">
          <button
            type="button"
            class="text-white block text-base"
            role="menuitem"
            tabindex="-1"
            (click)="onNavigate(['/profile'])"
            >
            My Profile
          </button>

          @if (canViewEvents$ | async) {
            @if (eventsRoute$ | async; as eventsRoute) {
              <button
                type="button"
                class="text-white-700 block text-base"
                role="menuitem"
                (click)="onNavigate(eventsRoute)"
                tabindex="-1"
                >
                Events
              </button>
            }
          }

          @if (isSuperAdmin$ | async) {
            <button
              type="button"
              class="text-white-700 block text-base"
              role="menuitem"
              (click)="onNavigate(['/admin', 'part-numbers'])"
              tabindex="-1"
            >
              Part Numbers
            </button>
          }
          <button
            type="button"
            class="text-white block text-base"
            role="menuitem"
            tabindex="-1"
            (click)="onSignOut()"
            >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  }
}
